import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import RocketLaunchRoundedIcon from "@mui/icons-material/RocketLaunchRounded";

// Shown when useVersionCheck() detects the deployed build no longer matches
// the one this tab is running. There is no in-place hot-swap for a CRA SPA
// behind CloudFront, so the only way forward is a hard reload.
function NewVersionDialog({ version }) {
    const handleRefresh = () => {
        window.location.reload();
    };

    return (
        <Dialog
            open={Boolean(version)}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") {
                    return;
                }
            }}
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden",
                    maxWidth: 420,
                },
            }}
        >
            <Box
                sx={{
                    background:
                        "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
                    px: 3,
                    pt: 4,
                    pb: 5,
                    textAlign: "center",
                    color: "#fff",
                }}
            >
                <Avatar
                    sx={{
                        bgcolor: "rgba(255,255,255,0.18)",
                        width: 64,
                        height: 64,
                        mx: "auto",
                        mb: 2,
                    }}
                >
                    <RocketLaunchRoundedIcon sx={{ fontSize: 32 }} />
                </Avatar>
                <Typography variant="h6" fontWeight={700}>
                    A new version of Starek is available
                </Typography>
            </Box>

            <DialogContent sx={{ px: 3, pt: 3, pb: 1, textAlign: "center" }}>
                <Typography variant="body2" color="text.secondary">
                    We've made some improvements. Refresh now to update to
                    {version ? (
                        <>
                            {" "}
                            <Box component="span" fontWeight={700} color="text.primary">
                                v{version}
                            </Box>
                        </>
                    ) : (
                        " the latest version"
                    )}
                    .
                </Typography>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
                <Button
                    fullWidth
                    variant="contained"
                    size="large"
                    onClick={handleRefresh}
                    sx={{
                        background:
                            "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        py: 1.25,
                        boxShadow: "none",
                        "&:hover": {
                            background:
                                "linear-gradient(135deg, #0a58ca 0%, #084298 100%)",
                            boxShadow: "none",
                        },
                    }}
                >
                    Refresh now
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default NewVersionDialog;
